import { Link } from 'react-router-dom'
import { ROUTES } from '@/utils/constants'
import { useTranslation } from 'react-i18next'

export function Hero() {
  const { t } = useTranslation()

  const handleSmoothScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    if (href.startsWith('#')) {
      e.preventDefault()
      const target = document.querySelector(href)
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }
  }

  return (
    <section className="hero">
      <div className="container">
        <div className="hero-content">
          <h2>{t('landing.hero.title')}</h2>
          <h3>{t('landing.hero.subtitle')}</h3>
          <div className="hero-buttons">
            <Link to={ROUTES.LOGIN} className="btn-primary">
              <i className="fas fa-rocket"></i> {t('landing.hero.startLearning')}
            </Link>
            <a href="#features" className="btn-secondary" onClick={(e) => handleSmoothScroll(e, '#features')}>
              <i className="fas fa-play"></i> {t('landing.hero.learnMore')}
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}
